<template>
  <div>
    <v-container class="pa-4">
      <v-row
        v-if="
          looks &&
          Object.values(this.$store.state.product.products)[0] &&
          Object.values(this.$store.state.product.products)[0].gender
        "
        class="mt-0 pt-0"
        justify="center"
        align="center"
      >
        <v-col class="mt-0 pt-0" cols="auto">
          <v-btn
            :color="male ? 'rgb(17, 65, 206)' : ''"
            :dark="male ? true : false"
            @click="male_func()"
          >
            <v-icon class="ma-1"> mdi-human-male </v-icon>
            {{ $t("looks.male") }}
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0" cols="auto">
          <v-btn
            :color="female ? 'rgb(17, 65, 206)' : ''"
            :dark="female ? true : false"
            @click="female_func()"
          >
            <v-icon class="ma-1"> mdi-human-female </v-icon>
            {{ $t("looks.female") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" lg="12" style="text-align: center">
          <v-btn large @click="befor_newLook()">
            <v-icon> mdi-plus </v-icon>
            <b>{{ $t("looks.new_look") }}</b>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-show="look.length" dense justify="center" no-gutters>
        <v-col
          cols="12"
          sm="10"
          :class="!$store.state.isMobile ? 'pl-12 ml-12' : ''"
        >
          <v-pagination
            v-model="page"
            :length="lengthPages"
            :total-visible="7"
            circle
          />
        </v-col>
        <v-col cols="12" sm="1" class="justify-center">
          <v-combobox
            v-model="perpage"
            :items="per_pages"
            solo
            @change="MinValidePagination(perpage)"
          />
        </v-col>
      </v-row>
      <v-row
        v-for="(look, index) in article_change()"
        v-show="look"
        :key="index"
      >
        <v-col cols="12" sm="12" class="pb-0 pt-0">
          <v-row dense no-gutters justify="center" align="center">
            <v-col cols="12" sm="8">
              <v-row dense>
                <v-col cols="12" sm="6" class="text-center">
                  <v-combobox
                    v-model="look.style_arr"
                    class="mt-1"
                    :items="$store.state.look.looks_styles"
                    :menu-props="{ bottom: true, offsetY: true }"
                    outlined
                    dense
                    multiple
                    hide-selected
                    :label="$t('looks.look_row.style')"
                    small-chips
                    deletable-chips
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            No "<strong>Styles</strong>" avilable add new one
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-combobox>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="3" class="mb-4 text-center">
              <v-btn class="" rounded @click="saveLook(look, index)">
                <b>{{ $t("looks.look_row.btns.save") }}</b>
              </v-btn>
              <v-btn rounded class="ml-5" @click="deleteLook(look, index)">
                <b>{{ $t("looks.look_row.btns.delete") }}</b>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="3" class="pt-0">
          <label :for="'look-' + index">
            <v-img
              :src="look.picture_url"
              class="modifiable look-picture"
              width="100%"
              aspect-ratio=".64"
              cover
            />
          </label>
          <input
            :id="'look-' + index"
            type="file"
            @change="chosePicture(look, index)"
          />
        </v-col>

        <v-col
          v-for="(product, idx) in look.product_ids"
          :key="idx"
          cols="6"
          sm="3"
          md="3"
          lg="3"
          class="pt-0"
        >
          <product-card
            class="modifiable"
            :product="product"
            @click="choseProduct(look, idx)"
          />
        </v-col>
        <v-divider class="ma-5" />
      </v-row>

      <!--
      <v-layout v-for="look in looks">
          <v-flex xs5 md5 lg5>
            <img :src="'https://storage.googleapis.com/cleed-datacenter-europe/fraiche/looks/' + look.picture_url" class="modifiable look-picture"></img>
          </v-flex>
          <v-flex xs4 md4 lg4 v-for="product in look.product_ids">
            <product-card class="modifiable" :product="product"></product-card>
          </v-flex>
      </v-layout>
      -->
      <v-row v-show="look.length" class="mb-12" justify="center">
        <div class="card-footer pb-0 pt-3">
          <v-pagination
            v-model="page"
            :length="lengthPages"
            :total-visible="7"
            circle
          />
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    newLookClicked: false,
    newLooks: [],
    select: undefined,
    total: 0,
    page: 1,
    perpage: 10,
    per_pages: ["10", "30", "60"],
    lengthPages: 0,
    articles: [],
    male_articles: [],
    female_articles: [],
    male: false,
    female: false,
    gender: "",
    look: [],
    show: false,
  }),
  created() {
    if (!this.$store.state.product.products) {
      //fetch products
      this.$store.dispatch("setLoader", {
        showing: true,
        text: "Fetching products",
      });
      this.$store.dispatch("FETCH_PRODUCTS").then(() => {
        this.$store.dispatch("setLoader", {
          showing: false,
          text: "Fetching looks",
        });
      });
    }
    //fetch looks
    this.$store.dispatch("setLoader", {
      showing: true,
      text: "Fetching looks",
    });
    this.$store.dispatch("FETCH_LOOKS").then((r) => {
      this.$store.dispatch("setLoader", {
        showing: false,
        text: "Fetching looks",
      });
    });
  },
  computed: {
    looks: {
      get: function () {
        const look = Object.values(this.$store.state.look.looks);
        this.gender_check(this.male, this.female);
        this.article_change();
        return look;
      },
      look_male: {
        get: function () {
          const look = this.$store.state.look.look_male;
          return look;
        },
      },
      look_female: {
        get: function () {
          const look = this.$store.state.look.look_female;
          return look;
        },
      },
    },
  },
  watch: {
    newLooks: {
      deep: true,
    },
  },
  destroyed() {
    this.$store.dispatch("selector/select", {
      active: false,
    });
  },
  methods: {
    test() {
      console.log(this.$store.state.look.latest_id);
    },
    article_change() {
      // console.log('here');
      if (!this.male && !this.female) {
        // console.log('all', this.articles);
        this.total = Object.values(this.articles).length;
        this.look = this.articles;
        return this.pagenated(this.articles);
      } else if (this.male && !this.female) {
        // console.log('male', this.male_articles);
        this.total = Object.values(this.male_articles).length;
        this.look = this.male_articles;
        return this.pagenated(this.male_articles);
      } else {
        // console.log('female',this.female_articles);
        this.total = Object.values(this.female_articles).length;
        this.look = this.female_articles;
        return this.pagenated(this.female_articles);
      }
    },
    gender_check(m, f) {
      if (!m && !f) {
        const look = Object.values(this.$store.state.look.looks);
        this.articles = look;
      }
    },
    male_func() {
      this.page = 1;
      if (this.male) {
        this.male = false;
        this.female = false;
        return;
      }
      this.male = true;
      this.female = false;
      this.gender = "male";
      this.male_articles = this.$store.state.look.look_male;
      if (!this.male_articles.length) {
        this.$store.dispatch("setSnackbar", {
          text: `No looks in gender '${this.$t(
            "looks.male"
          )}' Add new look to have it`,
          color: "warning",
          timeout: 6000,
        });
      }
    },
    female_func() {
      this.page = 1;
      if (this.female) {
        this.male = false;
        this.female = false;
        return;
      }
      this.male = false;
      this.female = true;
      this.gender = "female";
      this.female_articles = this.$store.state.look.look_female;
      if (!this.female_articles.length) {
        this.$store.dispatch("setSnackbar", {
          text: `No looks in gender '${this.$t(
            "looks.female"
          )}' Add new look to have it`,
          color: "warning",
          timeout: 6000,
        });
      }
    },
    pagenated(look) {
      const page = this.page;
      const perpage = this.perpage;
      const from = page * perpage - perpage;
      const to = page * perpage;
      this.lengthPages = Math.ceil(this.total / this.perpage);
      const res = Object.keys(look)
        .slice(from, to)
        .reduce((result, key) => {
          result[key] = look[key];
          return result;
        }, {});
      return Object.values(res);
    },
    MinValidePagination(page) {
      if (isNaN(page)) {
        this.$store.dispatch("setSnackbar", {
          text: `" ${page} " Is not a Number`,
          color: "warning",
        });
        this.perpage = 10;
      }
      if (page < 10) {
        this.$store.dispatch("setSnackbar", {
          text: "The minimum perpage to display is 10",
          color: "warning",
        });
        this.perpage = 10;
      }
      this.page = 1;
    },
    chosePicture(look, index) {
      var file = document.querySelector("#look-" + index).files[0]; // sames as here
      var reader = new FileReader();

      reader.onloadend = function () {
        console.log("LOAD FILE ENDED");
        look.picture_url = reader.result;
      };

      if (file) {
        console.log("FILE !");
        reader.readAsDataURL(file); // reads the data as a URL
      } else {
        console.log("NO FILE !");
        look.picture_url = "";
      }
    },
    choseProduct(look, index) {
      this.$store
        .dispatch("selector/select", {
          active: true,
          multiple: false,
        })
        .then((p) => {
          console.log("THEN");
          console.log(p);
          //        look.product_ids[index] = p
          this.$set(look.product_ids, index, p);
        });
    },
    befor_newLook() {
      if (!Object.values(this.$store.state.product.products)[0].gender) {
        this.newLook();
      } else {
        if (this.male || this.female) {
          this.newLook();
        } else {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("looks.gender_check"),
            color: "error",
          });
        }
      }
    },
    newLook() {
      var product_placeholder = {
        picture_url:
          "https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg",
        selected: false,
        // category: "NAN",
        // price: "??"
      };
      var newLook = {
        // id: this.$uuid.v4(),
        id: this.$store.state.look.latest_id,
        new: true,
        picture_url:
          "https://dimensionmill.org/wp-content/uploads/2019/03/square-placeholder.jpg",
        product_ids: [
          product_placeholder,
          product_placeholder,
          product_placeholder,
        ],
        style: "",
      };
      this.page = 1;

      if (!this.male && !this.female) {
        this.$store.state.look.looks.unshift(newLook);
      } else if (this.male && !this.female) {
        this.$store.state.look.look_male.unshift(newLook);
      } else {
        this.$store.state.look.look_female.unshift(newLook);
      }
    },
    add_newStyle_store(styles) {
      styles.forEach((element) => {
        if (!this.$store.state.look.looks_styles.includes(element)) {
          this.$store.state.look.looks_styles.push(element);
        }
      });
    },
    saveLook(look, index) {
      if (look.style_arr) look.style = look.style_arr;
      else look.style = [];
      this.add_newStyle_store(look.style);
      if (this.gender) look.gender = this.gender;
      else look.gender = "";
      console.log("save->", look);
      var copy = JSON.parse(JSON.stringify(look));
      for (var i = 0; look.product_ids[i]; i++) {
        var product = look.product_ids[i];
        if (
          product.picture_url ==
            "https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg" ||
          product.category == "" ||
          !product.product_id
        ) {
          // SNACKBAR A Product is not defined
          this.$store.dispatch("setSnackbar", {
            text: "Produit manquant",
            color: "error",
            timeout: 3000,
          });
          return;
        } else {
          copy.product_ids[i] = product.product_id;
        }
      }
      if (
        look.picture_url == "" ||
        look.picture_url ==
          "https://dimensionmill.org/wp-content/uploads/2019/03/square-placeholder.jpg"
      ) {
        this.$store.dispatch("setSnackbar", {
          text: "Image look manquante",
          color: "error",
        });
        return;
      }
      this.$store.dispatch("setLoader", {
        showing: true,
        text: "Saving the look",
      });
      this.$store
        .dispatch("UPDATE_LOOK", copy)
        .then((r) => {
          if (this.gender && this.look[index].new) {
            this.$store.state.look.looks.push(look);
          }
          this.look[index].new = false;
          this.$store.dispatch("setLoader", {
            showing: false,
            text: "Saving the look",
          });
          this.$store.dispatch("setSnackbar", {
            text: "Look sauvegardé",
            color: "info",
          });
        })
        .catch((r) => {
          if (r.response.status == 413) {
            this.$store.dispatch("setSnackbar", {
              text: "L'image doit faire 3mb maximum",
              color: "error",
            });
          }
        });
    },
    index_gender(look, arr) {
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        if (look.id === element.id) {
          return i;
        }
      }
    },
    deleteLook(look, index) {
      this.selected = { look: look, index: index };
      this.$store
        .dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: this.$t("show_box.look_del"),
        })
        .then((confirmation) => {
          if (confirmation) {
            this.deleteSelected(true);
          }
        });
    },
    deleteSelected(ok) {
      if (ok) {
        console.log("here", this.selected);
        this.$store.dispatch("setLoader", {
          showing: true,
          text: "Deleting the look",
        });
        console.log(this.selected);
        if (!this.male && !this.female) {
          this.$store.state.look.looks.splice(
            this.index_gender(this.selected.look, this.$store.state.look.looks),
            1
          );
          if (this.selected.look.gender === "male") {
            const idx_male = this.index_gender(
              this.selected.look,
              this.$store.state.look.look_male
            );
            this.$store.state.look.look_male.splice(idx_male, 1);
          } else if (this.selected.look.gender === "female") {
            const idx_female = this.index_gender(
              this.selected.look,
              this.$store.state.look.look_female
            );
            this.$store.state.look.look_female.splice(idx_female, 1);
          }
        } else if (this.male && !this.female) {
          this.$store.state.look.look_male.splice(this.selected.index, 1);
          const idx = this.index_gender(
            this.selected.look,
            this.$store.state.look.looks
          );
          this.$store.state.look.looks.splice(idx, 1);
        } else {
          this.$store.state.look.look_female.splice(this.selected.index, 1);
          const idx = this.index_gender(
            this.selected.look,
            this.$store.state.look.looks
          );
          this.$store.state.look.looks.splice(idx, 1);
        }
        // this.look.splice(this.selected.index, 1);
        var promise = this.selected.look.id
          ? this.$store.dispatch("DELETE_LOOK", this.selected.look)
          : Promise.resolve({ response: true });
        promise.then((r) => {
          console.log("DELETEEEED");
          console.log(r);
          this.$store.dispatch("setLoader", {
            showing: false,
            text: "Deleting the look",
          });
          this.$store.dispatch("setSnackbar", {
            text: "Look supprimé",
            color: "info",
            timeout: 3000,
          });
        });
      }
      this.selected = undefined;
    },
  },
};
</script>

<style scoped>
.look-picture {
  width: 100%;
}
.add-look-icon {
  font-size: 48px;
  padding: 8px;
  border-radius: 50%;
}
.add-look-icon:hover {
  background: rgba(0, 0, 0, 0.2);
}
.save-look {
  left: 0;
  position: absolute;
  margin-top: 18px;
}
.delete-look {
  position: absolute;
  right: 0;
  margin-top: 18px;
}
.modifiable:hover {
  border: 1px solid #ccc;
  cursor: pointer;
  border-radius: 2px;
}
input {
  display: none;
}
.pages {
  width: 30%;
}
@media only screen and (max-width: 500px) {
  .pages {
    width: 100%;
  }
}
</style>
